import { useEffect } from 'react';
type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
type MetaPixelWindow = Window & {
  fbq?: FbqFunction;
  _fbq?: FbqFunction;
};
const META_PIXEL_ID = '1759615398541763';
const META_PIXEL_SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  useEffect(() => {
    const metaWindow = window as MetaPixelWindow;
    if (!metaWindow.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
          return;
        }
        fbq.queue.push(args);
      } as FbqFunction;
      fbq.queue = [];
      fbq.loaded = true;
      fbq.version = '2.0';
      metaWindow.fbq = fbq;
      metaWindow._fbq = fbq;
    }
    if (!document.getElementById(META_PIXEL_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = META_PIXEL_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    metaWindow.fbq('init', META_PIXEL_ID);
    metaWindow.fbq('track', 'PageView');
  }, []);
  return null;
}